// src/components/ProductCard.jsx
import React from 'react';
import './ProductCard.css';
import cart from './cart.png';
import cloud from './co2.png'

const ProductCard = ({ product }) => {
  if (!product) return null;

  const {
    name,
    price,
    link,
    category,
    impact,
    imageUrl,
    commission,
    cO2Equivalent,
    unsustainableEquivalent
  } = product;

    // Split numeric and text parts from the impact string
    const impactMatch = impact?.match(/^([\d\-–%.\s]+)\s*(.*)$/);
    const impactValue = impactMatch ? impactMatch[1] : '-';
    const impactText = impactMatch ? impactMatch[2] : '';

  return (
    <div className="product-card minimal">
      <div className="image-box-product">
        <img
          src={imageUrl || '/default.png'}
          alt={name}
        />
        <span className="category-tag">{category}</span>
      </div>

      <h4 className="product-title">{name}</h4>

      <div className="metrics-row">
        <div className="metrics-left">
          
            <span className="unsustainable-label">
              Unsustainable Eqv. 
              <span className="unsustainable-value">
                {unsustainableEquivalent || '-'}
              </span>
            </span>
          
          <div className="Co2-div">
            <span className='Co2-div-img'> <img src={cloud} alt="Co2image" /></span>
            <span className="co2-badge">
              {cO2Equivalent || '-'}
            </span>
          </div>
        </div>

        <div className="metrics-right">
          <span className="impact-label">🍃Impact</span>
          <span className="impact-value">{impactValue}</span>
          {impactText && (
            <span className="impact-label impact-text-extra">{impactText}</span>
          )}
        </div>
      </div>

      <div className="bottom-row">
        <span className="price">₹{price}</span>
        <a
          className="buy-btn"
          href={link}
          target="_blank"
          rel="noopener noreferrer"
        >
           <img src={cart} alt="" /> Buy Now
        </a>
      </div>
    </div>
  );
};

export default ProductCard;
